// extracted by mini-css-extract-plugin
export default {"signupPage":"Singup_signupPage__2zBGz","headingText":"Singup_headingText__RTrkN"};